export function getImpersonationHeaders(assumedUserId?: string): Record<string, string> {
  return assumedUserId ? { "X-PGA-Impersonation": `BackofficeUser/${assumedUserId}` } : {};
}
